import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
export default {
  name: 'back_to_top_config',
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      depot: {}
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture() {
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload() {
      this.$refs.uploadBanner.uploadBanner();
    },
    onDelete: function onDelete() {
      var _this2 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.imageurl = '';
      });
    },
    emitUploadFile: function emitUploadFile(src) {
      this.value.config.imageurl = "".concat(this.$ossurl).concat(src);
    }
  },
  created: function created() {
    this.$set(this.value, 'config', _objectSpread({
      margin_top: 15,
      z_index: 2,
      imageurl: 'https://res.youlianfuwu.com/mini_program/shop/top.png'
    }, this.value.config));
    this.getPicture();
  }
};